import styled from '@emotion/styled';
import { Link } from '@reach/router';
import { Accordion, AccordionButton, AccordionPanel } from 'react-magma-dom';
import { COLORS } from '../../constants';

export const StyledLessonSideNav = styled.aside`
  background-color: ${COLORS.slate};
  min-height: calc(100vh - 173px);
  width: 252px;
  padding: 122px 0 0 24px;
`;

export const StyledAccordion = styled(Accordion)`
  background: none;
  border: none !important;
  height: 100%;
`;

export const StyledAccordionButton = styled(AccordionButton)`
  font-size: 12px;
  border: none !important;
  font-weight: bold;
  line-height: 1.33;
  letter-spacing: 0.32px;
  color: ${COLORS.lavenderGray} !important;
  background: none;
`;

export const StyledAccordionPanel = styled(AccordionPanel)`
  background: none;
  margin: 6px 0 0 16px;
  padding: 10px 6px 6px 16px;
  border-top: solid 1px ${COLORS.darkSpringGreen};
`;

export const StyledAccordionLink = styled(Link)`
  background: none;
  text-decoration: none;
  display: inline-block;
  font-size: 12px;
  font-weight: bold;
  line-height: 1.33;
  letter-spacing: 0.32px;
  color: ${COLORS.lavenderGray};
  padding: 9px;

  p {
    margin: 0;
  }

  &.active {
    color: white;
  }

  :focus {
    outline: 2px dotted ${COLORS.blueCola};
  }
`;
